<template>
  <header id="header">
    <b-container>
      <b-row
        align-v="center"
        class="justify-content-md-between"
      >
        <b-col
          class="text-center text-md-left"
          md="4"
        >
          <h1 class="d-inline-block">
            <router-link :to="`/${$t('lang')}/`">
              <img
                alt=""
                :src="`${$t('baseurl')}img/icons/space.svg`"
              />
              <span v-html="$t('color.space')"></span>
            </router-link>
          </h1>
        </b-col>
        <b-col
          class="d-flex justify-content-center justify-content-md-end"
          md="8"
        >
          <b-nav
            class="list-unstyled justify-content-center"
            pills
          >
            <b-nav-text v-show="false">
              <a
                class="btn btn-outline-secondary text-uppercase mx-1"
                href="https://www.frama.space/login"
                v-html="$t('menu.signin')"
              ></a>
            </b-nav-text>
            <b-nav-text v-show="false">
              <a
                class="btn btn-primary text-uppercase mx-1"
                href="https://www.frama.space/new"
                v-html="$t('menu.signup')"
              ></a>
            </b-nav-text>
            <b-nav-text>
              <router-link
                class="btn btn-outline-secondary text-uppercase mx-1"
                :to="`/${$t('lang')}/news`"
              >
                {{ $t('menu.news') }}
                <b-badge
                  pill
                  variant="light"
                >
                  <span v-text="Object.keys($t('news.posts')).length"></span>
                </b-badge>
              </router-link>
            </b-nav-text>
            <b-nav-text>
              <a
                class="btn btn-outline-secondary text-uppercase mx-1"
                href="https://forum.frama.space"
              >
                {{ $t('menu.forum') }}
              </a>
            </b-nav-text>
            <b-nav-text>
              <router-link
                class="btn btn-outline-secondary text-uppercase mx-1"
                :to="`/${$t('lang')}/faq`"
              >
                <span v-html="$t('menu.faq')"></span>
              </router-link>
            </b-nav-text>
            <b-nav-text>
              <router-link
                class="btn btn-outline-secondary text-uppercase mx-1"
                :to="`/${$t('lang')}/csu`"
              >
                <span v-html="$t('menu.csu')"></span>
              </router-link>
            </b-nav-text>
            <b-nav-text>
              <router-link
                class="btn btn-outline-secondary text-uppercase mx-1"
                :to="`/${$t('lang')}/rgpd`"
              >
                <span v-html="$t('menu.rgpd')"></span>
              </router-link>
            </b-nav-text>
            <b-nav-text
              class="nav-item d-none"
              tag="li"
            >
              <I18n />
            </b-nav-text>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
import I18n from '../../commons/components/I18n.vue';

export default {
  components: {
    I18n,
  },
};
</script>

<style lang="scss">
#header {
  background: #fff;
  border-bottom: 1px solid var(--f-g4);

  h1 {
    margin: 0;
    line-height: normal;
    font-size: 2rem;

    a {
      text-decoration: none;
      display: flex;
      align-items: center;

      img {
        width: 64px;
        height: 64px;
        padding: .25rem .25rem .25rem 0;
      }
    }
  }

  .btn {
    border: transparent;
  }
}
</style>
